import UltraRateToast from './UltraRateToast'

export default UltraRateToast
